import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import styled from "styled-components";


export const PrevArrow: React.SFC<any> = (props) => (
	<a className={props.className} style={props.style} onClick={props.onClick}>
		<Icon icon={IconNames.CHEVRON_LEFT} />
	</a>
);

export const NextArrow: React.SFC<any> = (props) => (
	<a className={props.className} style={props.style} onClick={props.onClick}>
		<Icon icon={IconNames.CHEVRON_RIGHT} />
	</a>
);

export const WrapperDiv = styled.div`
	box-sizing: border-box;
	display: block;
	position:relative;
	width:100%;
`;



// WEBPACK FOOTER //
// ./src/common/views/carousel/fragments.tsx